import ApplicationSerializer from 'volta/_pods/application/serializer';


export default class PoTaskSerializer extends ApplicationSerializer {
  modelNameFromPayloadKey(key: string) {
    if (key === 'tasks') {
      return 'po-task';
    }
    return super.modelNameFromPayloadKey(key);
  }
}
